import React from 'react'
import { CellRenderer } from '../../legacy-design-system/grid'
import { Route } from '../../graphql/schema/types/route'
import { css } from '@emotion/css'

const statusCellCss = css`
  font-size: 14px;
  margin-top: 10px;
  padding: 10px;
  text-align: left;
`

export function getApplicationCellRenderer(): CellRenderer<Route> {
  return function applicationCellRenderer({
    rowData: { app },
    getCellContentProps
  }) {
    return (
      <div {...getCellContentProps({ className: statusCellCss })}>
        <p>{app.name}</p>
      </div>
    )
  }
}
